
// axios base url on cti backend
export const BaseApiUrlKey = process.env.REACT_APP_BASE_API_URL;

// axios hokhuwa base url on phishing module backend
export const HokhuwaApiUrlKey = process.env.REACT_APP_HOKHUWA_API_URL;
